var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8984 4.7526C16.2967 4.7526 14.9984 3.45938 14.9984 1.85767C14.9984 2.66106 14.6753 3.38112 14.1511 3.90524C13.6269 4.42937 12.9021 4.7526 12.1035 4.7526C12.9021 4.7526 13.627 5.07602 14.1511 5.59995C14.6752 6.12894 14.9984 6.85404 14.9984 7.65236C14.9984 6.05065 16.2965 4.7526 17.8984 4.7526Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2153 2.81568C10.2153 2.04175 10.8426 1.4145 11.6165 1.4145C10.8425 1.4145 10.2153 0.789728 10.2153 0.015625C10.2153 0.403731 10.059 0.751777 9.80578 1.005C9.55256 1.25821 9.20222 1.41451 8.81641 1.41451C9.20221 1.41451 9.55256 1.57081 9.80578 1.82403C10.0592 2.07954 10.2153 2.42989 10.2153 2.8157V2.81568Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7837 2.81568C19.7837 2.04175 20.411 1.4145 21.1848 1.4145C20.4109 1.4145 19.7837 0.789728 19.7837 0.015625C19.7837 0.403731 19.6274 0.751777 19.3741 1.005C19.1209 1.25822 18.7706 1.41451 18.3848 1.41451C18.7706 1.41451 19.1209 1.57081 19.3741 1.82403C19.6276 2.07954 19.7837 2.42989 19.7837 2.8157V2.81568Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31218 6.71559C4.88102 6.59934 4.46094 6.92553 4.46094 7.37189V7.55191C6.72974 7.90825 10.4724 8.63934 13.3152 9.85825C11.0012 8.35807 7.04148 7.1843 5.31247 6.71563L5.31218 6.71559Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5398 7.55189V7.37188C25.5398 6.92553 25.1197 6.59937 24.6886 6.71558C22.9598 7.18425 19.0035 8.35436 16.6895 9.8543C19.5361 8.63934 23.2672 7.91191 25.5395 7.55191L25.5398 7.55189Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43727 8.15186C3.06228 8.09938 2.72852 8.39172 2.72852 8.77063V8.81183L12.8762 10.4881C9.61736 9.13041 5.15466 8.39932 3.43744 8.15182L3.43727 8.15186Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2724 8.81182V8.77038C27.2724 8.39171 26.9386 8.09911 26.5637 8.15162C24.8461 8.39908 20.376 9.13039 17.1172 10.4918L27.2724 8.81182Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00762129 10.3427L1.55223 22.7127C1.65743 23.5542 2.31325 24.2212 3.153 24.3399L14.4852 25.9442V11.514L1.09282 9.29952C0.473109 9.19708 -0.0703429 9.71962 0.00744459 10.3425L0.00762129 10.3427Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9083 9.29984L15.2354 11.5606V25.9842L26.8475 24.3402C27.6872 24.2212 28.3433 23.5546 28.4483 22.713L29.9929 10.343C30.0709 9.72013 29.5274 9.19754 28.9077 9.30002L28.9083 9.29984Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/Library.4abd0638ec704f54170f2b255e121f34.svg";
export { ForwardRef as ReactComponent };